import { FC, useCallback, useMemo } from "react";
import { OrderReviewDto } from "../../../../dtos";
import { Box } from "@mui/material";
import { useGetOrderReviewQuery } from "../../../../store/generated/generatedApi";
import { format } from "date-fns";
import { DataTableColumn, StandardListViewV2 } from "../../../CoreLib/library";
import { AddCircle } from "@mui/icons-material";

export interface IOrderReviewSelectList {
    date: Date;
    onSelect: (orderReview: OrderReviewDto) => void;
}

const defaultPaginationProps = {
    sortKey: 'CUSTOMER',
    sortAsc: true,
    page: 0,
    pageSize: 25,
};

export const OrderReviewSelectList: FC<IOrderReviewSelectList> = (props) => {
    const { date, onSelect } = props;
    const tableColumns: DataTableColumn<OrderReviewDto>[] = useMemo(() => [
        { key: 'projectName', label: 'Project Name', sortKey: 'PROJECT_NAME' },
        { key: 'jobName', label: 'Job Name', sortKey: 'JOB_NAME' },
        { key: 'customerName', label: 'Customer', sortKey: 'CUSTOMER' },
        { key: 'quote.addressLine1', label: 'Address', sortKey: 'ADDRESS' },
        { key: 'quote.city', label: 'City', sortKey: 'CITY' },
        { key: 'quote.state', label: 'State', sortKey: 'STATE' },
        { key: 'quote.zipCode', label: 'Zip', sortKey: 'ZIP_CODE' },
        { key: 'quote.quoteNumber', label: 'Quote #', sortKey: 'QUOTE_NUMBER' },
        { key: 'customerJobNumber', label: 'Job #', sortKey: 'JOB_NUMBER' },
        { key: 'poNumber', label: 'PO #', sortKey: 'PO_NUMBER' },
        { key: 'orderNumber', label: 'Order #', sortKey: 'ORDER_NUMBER' },
        { key: 'orderLineItemCount', label: 'Line Items Count', sortKey: 'LINE_ITEM_COUNT' },
        { key: 'statusName', label: 'Order Status', sortKey: 'STATUS' }
    ], []);
    
    const handleSelect = useCallback((__: string, record: OrderReviewDto) => {
        onSelect(record);
    }, [onSelect]);
    return (
        <Box sx={{ height: '60vh', overflow: 'auto', width: '100%' }}>
            <StandardListViewV2
                headerIcon={<></>}
                headerTitle=''
                breadCrumbs={[]}
                defaultPaginationProps={defaultPaginationProps}
                getDataQuery={useGetOrderReviewQuery}
                isShowActiveToggleVisible={false}
                tableColumns={tableColumns}
                entityNameSingular='OrderReview'
                permissionName='review'
                handleEdit={handleSelect}
                editToolTip='Select Order Review'
                editIcon={<AddCircle color="primary" />}
                additionalQueryParameters={{ 
                    orderDate: format(date, "yyyy-MM-dd"),
                }}
                disableSelection
                maxTableHeight={'48vh'}
            />
        </Box>
    );
}